import { MouseEvent } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { colorPalette } from '../../../style/colorPalette'
import {
  RequestStatus,
  TaskActualWorkApprovalStatusRow,
} from '../taskActualWorkApprovalStatus'

// The grid context shape extended with the click handler for this cell
type GridContext = {
  onRequestStatusCellClick?: (
    event: MouseEvent<HTMLElement>,
    rowData: TaskActualWorkApprovalStatusRow
  ) => void
}

type Props = ICellRendererParams<TaskActualWorkApprovalStatusRow> & {
  context: GridContext
}

const isClickableStatus = (status: RequestStatus | undefined): boolean => {
  return (
    status === RequestStatus.UNREQUESTED || status === RequestStatus.UNAPPROVED
  )
}

export const RequestStatusCellRenderer = (props: Props) => {
  const { value, data, context } = props
  const clickable = isClickableStatus(data?.requestStatus)

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    if (!clickable || !data || !context.onRequestStatusCellClick) return
    context.onRequestStatusCellClick(e, data)
  }

  return (
    <div
      className="sevend-ag-cell"
      onClick={handleClick}
      style={{
        color: clickable ? colorPalette.blue[7] : undefined,
        cursor: clickable ? 'pointer' : undefined,
      }}
    >
      {value}
    </div>
  )
}
